import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ScrollService {

  private lastPositions = new Map<string, number>();
  private currentUrl = '';

  constructor(private router: Router) {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.currentUrl) {
          this.lastPositions.set(this.currentUrl, window.scrollY);
        }
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Skip on TV: row-based pages (CategoryMovieComponent, etc.) own their
        // scroll position via scheduleActiveRowReposition. Restoring a saved
        // position fights the row reposition and the trailing scrollBehavior
        // reset wipes app.component.ts's instant-scroll override, allowing the
        // CSS smooth-scroll to kick back in and break the defender.
        if (document.body.classList.contains('tv-mode')) {
          this.currentUrl = event.urlAfterRedirects;
          return;
        }
        const saved = this.lastPositions.get(event.urlAfterRedirects);
        const target = saved ?? 0;
        document.documentElement.style.scrollBehavior = 'auto';
        document.body.style.scrollBehavior = 'auto';
        requestAnimationFrame(() => {
          setTimeout(() => {
            window.scrollTo(0, target);
            document.documentElement.style.scrollBehavior = '';
            document.body.style.scrollBehavior = '';
          }, 0);
        });
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }
}